export const MainHeaderContentTestIds = {
  OPEN_SIDEBAR_BUTTON: 'main-header-content.open-sidebar-button',
  EXPAND_TOGGLE_BUTTON: 'main-header-content.expand-toggle-button',
};
